import { memo } from "react";
import { Navigate, generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import { DesignMagazinePlanArticleDefaultEditPresenter } from "./presenter";
import { usePlanArticleQuery } from "../../model/repository/query/use-plan-query";

type Props = {
	hotelID: string;
	planID: string;
};

export const DesignMagazinePlanArticleDefaultEditContainer = memo(({ hotelID, planID }: Props) => {
	const { data } = usePlanArticleQuery({ hotelID, planID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <DesignMagazinePlanArticleDefaultEditPresenter hotelID={hotelID} planID={planID} data={data} />;
});

DesignMagazinePlanArticleDefaultEditContainer.displayName = "DesignMagazinePlanArticleDefaultEditContainer";
